module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    This page has not been found. Please provide feedback ...\n  </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/misc-components/page-not-found.component.html
 ** module id = 148
 ** module chunks = 0
 **/